<template>
  <div>
        <div class="row ">
            <div class="col-md-12 card-wrapper">
                <div class="card">
                    <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('CLOUD_STORAGE_SYNCHRONIZATION')}}</div>
                    <div class="card-body bg-light pt-2">

                    <div v-if="cloudApiTokens.length<1">
                        <div class="row">
                            <div class="col-12 pt-2 pb-1">
                                <p class="description">{{$ml.get('CLOUD_STORAGE_SYNCHRONIZATION_COMMENT')}} </p>
                            </div> 
                        </div>
                        <div v-if="$can('can_add_cloud_api_token')" class=" row px-2">
                            <div class=" col-12 border  px-3 d-flex justify-content-between py-2 sync_start">
                                <img src="static/images/google-drive-icon.png" class="img-fluid">
                                <a :href="googleDriveAuthLink" type="button" class="btn bg-new-primary  px-2 text-center text-white">{{$ml.get('START_SYNCING')}}</a>  
                            </div>    
                        </div> 
                    </div>

                    <div v-if="cloudApiTokens.length>=1">
                        <div class="row">
                            <div class="col-12 py-2">
                                <img src="static/images/google_drive_icon.png" class="img-fluid">
                            </div>  
                        </div>
                        <div class="row px-2">
                            <div class="col-12 border px-2 d-flex justify-content-between align-items-center mt-2 py-1">
                                <div class="d-flex flex-column pt-2">
                                     <div>
                                        <label class="description font-weight-bold" for="">Senkronize Hesap:</label>
                                        <label class="description" for="">{{driveInfo.account_email}}</label>
                                    </div>
                                    <div>
                                        <label class="description font-weight-bold" for="">Senkronizasyon Başlangıcı:</label>
                                        <label class="description" for="">{{dateInfo}}</label>
                                    </div>
                                </div>
                                <div class="sync">
                                    <button type="button" class="btn bg-new-primary  px-2 text-center text-white" @click="syncWarning()">Senkronizasyonu Sonlandır</button> 
                                </div>
                                 
                            </div>
                        </div>
                    </div>

                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
    name:"documentManagement",
    data(){
        return{
            googleDriveAuthLink: '',
            driveConnection:false,
            cloudApiTokens: [],
            driveInfo:[],
            dateInfo:'',
        }
    },
    methods:{
        // syncWarning(){
        //     var confirm_message = this.$ml.get('SYNCHRONIZATION_MODAL_CONFIRM')
        //     Swal.fire({
        //     title: this.$ml.get('SYNCHRONIZATION_MODAL_TITLE'),
        //     text: confirm_message,
        //     icon: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: '#d33',
        //     confirmButtonText: this.$ml.get('SYNCHRONIZATION_MODAL_CONFIRM_BTN_TXT'),
        //     cancelButtonText: this.$ml.get('CANCEL'),
        //     customClass:{
        //         icon:'custom-warning',
        //         cancelButton:'custom-delete-cancel-button'
        //     },
        //     reverseButtons:true
        //     })
        // },
         syncWarning(){
            var confirm_message = this.$ml.get('SYNCHRONIZATION_MODAL_CONFIRM')
            Swal.fire({
            title: this.$ml.get('SYNCHRONIZATION_MODAL_TITLE'),
            text: confirm_message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: this.$ml.get('SYNCHRONIZATION_MODAL_CONFIRM_BTN_TXT'),
            cancelButtonText: this.$ml.get('CANCEL'),
            customClass:{
                icon:'custom-warning',
                cancelButton:'custom-delete-cancel-button'
            },
            reverseButtons:true
            }).then((response)=>{
            if(response.isConfirmed){
                axios({
           method: 'POST',
           url: '/deleteCloudApiToken',
           baseURL: this.baseUrl,
           data: {
             accountId: this.cloudApiTokens[0].accountId,
           },
        }).then(response => {
           this.listTokens()
        }).catch(error => {
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: error
           })
        });
            }
            }
            )},
        calculateGoogleDriveAuthLink: function() {
             this.googleDriveAuthLink = this.baseUrl + '/getGoogleDriveAccessToken';
             
        },
        listTokens: function() {
             axios({
                 method: 'get',
                 url: '/getAllDefaultCloudApiTokens',
                 baseURL: this.baseUrl,
             }).then(response => {
                 this.cloudApiTokens = response.data.content.tokens
             }).catch(error => {
                 console.log("documentManagement sayfası çalıştı");
                 console.log(error);
                 this.$notify({ 
                     group: 'foo',
                     type: 'error', 
                     title: this.$ml.get('ERROR'),
                     text: error
                 })
             });
        },
        getCloudApiTokensF: function(){
            axios({
                 method: 'get',
                 url: '/getCloudApiTokens',
                 baseURL: this.baseUrl,
            }).then(response => { 
                if(response.data.content.tokens[0]){
                this.driveInfo=response.data.content.tokens[0]
                // this.dateInfo=new Date(Date.parse(this.driveInfo.date)).toJSON()
                this.dateInfo=(moment(this.driveInfo.date).format('DD-MM-YYYY HH:mm'));
            }
            }).catch(error => {
                 this.$notify({ 
                     group: 'foo',
                     type: 'error', 
                     title: this.$ml.get('ERROR'),
                     text: error
                })
            });
        },
    },
    computed:{
        ...mapState([
             'baseUrl'
        ]),
     },
    mounted(){
        this.listTokens();
        this.calculateGoogleDriveAuthLink();
        this.driveConnection=false
        this.getCloudApiTokensF();
    }
}
</script>

<style scoped>
.description{
    font-size: 16px;
    line-height: 21px;
    color:#53565E;
}
.title{
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
    color: #53565E;
}
.border{
    background-color: #fff;
    border: 1px solid #e7e7e8;
    box-sizing: border-box;
    border-radius: 4px;
}
@media (max-width: 480px){
    .sync_start{
        padding-left: 3px !important;
        padding-right: 3px !important;
    }
    .sync{
        position: absolute;
        bottom: 16px;
        left: 8px;
    }
    .flex-column{
        padding-bottom: 50px;
    }
    .card-body{
        padding-bottom: 45px;
    }
    .img-fluid{
        width: 40%;
    }
}
</style>
